import { default as getCookie } from "@pb/utils/getCookie";
const mapProductArticleDetailsToRequestForBrands = (baseProductCode, praLocale, categoryParentKey, styleWithArticles) => {
    var _a;
    let baseProductCodeCopy = baseProductCode;
    if (!baseProductCode.includes('_group_')) {
        const prefix = baseProductCode === null || baseProductCode === void 0 ? void 0 : baseProductCode.slice(0, 7);
        const suffix = baseProductCode === null || baseProductCode === void 0 ? void 0 : baseProductCode.slice(baseProductCode.length - 3, baseProductCode.length);
        baseProductCodeCopy = `${prefix}_group_${suffix}`;
    }
    const finalPraLocale = praLocale === 'en' ? (_a = getCookie('HMCORP_locale')) === null || _a === void 0 ? void 0 : _a.toLowerCase() : praLocale;
    return {
        product_key: `${baseProductCodeCopy}_${finalPraLocale}`,
        category_parent_key: categoryParentKey,
        style_with_default_articles: styleWithArticles,
    };
};
export default mapProductArticleDetailsToRequestForBrands;
//# sourceMappingURL=mapProductArticleDetailsToRequestForBrands.js.map